/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { authAction } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import { LayoutWithNavbar } from 'layouts';
import { Stepper } from 'components';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { PATH } from 'shared/constant';
import moment from 'moment';
// import {
//   GoogleReCaptchaProvider,
//   GoogleReCaptcha,
// } from 'react-google-recaptcha-v3';
import './Otp.scss';

const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY;

let interval = null;
const timeout = null;
const CODE_LENGTH = new Array(6).fill(0);
const DEFAULT_TIMER = 60000;
class Otp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      focused: false,
      timer: DEFAULT_TIMER, // 120000
      isSubmitted: false,
      isRequestByEmail: false,
      tokenCaptcha: '',
      otpType: 'phone',
    };
    this.input = React.createRef();
  }

  componentDidMount() {
    const { token, error, history } = this.props;
    if (token && error === null) history.push(PATH.HOME);

    // redirect to login if state passed is undefined and is not isfromLogin
    if (history.location.state === undefined || !history.location?.state?.isFromLogin) history.push(PATH.LOGIN);

    // initial input typing
    this.input.current.style.caretColor = 'transparent';
    this.handleFocus();

    // start resend code duration
    this.resendCodeDuration();

    // on mount, save the recaptcha token on the state
    this.setState({ tokenCaptcha: this.props.history.location?.state?.recaptchaToken });
  }

  componentDidUpdate() {
    const { timer } = this.state;
    if (timer === 0) {
      clearInterval(interval);
    }
  }

  componentWillUnmount() {
    clearInterval(interval);
    clearTimeout(timeout);
  }

  // handleRecaptchaExecute = () => {
  //   if (window.grecaptcha) {
  //     window.grecaptcha.execute(captchaKey, { action: 'resend_otp' }).then((rToken) => {
  //       // Set the token in the state
  //       this.setState({ tokenCaptcha: rToken });
  //       // console.log('New reCAPTCHA Token:', rToken);
  //       return rToken;
  //     });
  //   }
  // }

  handleResendCode = () => {
    if (window.grecaptcha) {
      window.grecaptcha.execute(captchaKey, { action: 'resend_otp' }).then((rToken) => {
        // Set the token in the state
        this.setState({ tokenCaptcha: rToken });
        // console.log('New reCAPTCHA Token:', rToken);
        this.setState({ isSubmitted: false });

        this.setState({ timer: moment.duration(DEFAULT_TIMER, 'ms') }, () => { // original duration 120000,
        /** Call API to request for new OTP */
        // this.props.onRequestOTP(false, this.props.history.location?.state?.recaptchaToken);
          this.props.onRequestOTP(false, rToken);

          this.resendCodeDuration();
        });
        this.setState({
          isRequestByEmail: false,
          otpType: 'phone',
        });
      });
    }
  }

  handleRequestOtpOnEmail = () => {
    if (window.grecaptcha) {
      window.grecaptcha.execute(captchaKey, { action: 'resend_otp' }).then((rToken) => {
        // Set the token in the state
        this.setState({ tokenCaptcha: rToken });
        this.setState({ isSubmitted: false });
        this.setState({ timer: moment.duration(DEFAULT_TIMER, 'ms') }, () => {
        // this.props.onRequestOTP(true, this.props.history.location?.state?.recaptchaToken);
          this.props.onRequestOTP(true, rToken);
          this.resendCodeDuration();
        });
        this.setState({
          isRequestByEmail: true,
          otpType: 'email',
        });
      });
    }
  }

  resendCodeDuration = () => {
    interval = setInterval(() => {
      this.setState(state => ({
        timer: state.timer - 1000,
      }));
    }, 1000);
  }

  handleKeyDown = (e) => {
    if (e.keyCode === 13) { // on enter
      this.handleVerifyCode();
    }
  };

  handleKeyUp = (e) => {
    if (e.key === 'Backspace') {
      this.setState(state => ({
        value: state.value.slice(0, state.value.length - 1),
      }));
    }
  };

  /**
   * Verify OTP function
   * @param {*} otp
   */
  handleVerifyCode = (otp) => {
    const {
      onVerifytOTP, history,
    } = this.props;
    const { isRequestByEmail, tokenCaptcha, otpType } = this.state;

    this.setState({ isSubmitted: true });

    /** Call API to verify OTP code */
    onVerifytOTP(otp, history, isRequestByEmail, tokenCaptcha, otpType);
  }

  /**
   * Set the code and auto submit once every digit is filled in
   * @param {string} code
   */
  setCode = (code) => {
    this.setState({ value: code }, () => {
      const { value } = this.state;
      if (value.length === CODE_LENGTH.length) this.handleVerifyCode(value);
    });
  };

  handleChange = ({ target }) => {
    /** keep digits only, so pasted/autofilled codes with spaces or dashes still work */
    const digits = (target.value || '').replace(/\D/g, '');
    if (!digits) return;

    /** pasted or autofilled (one-time-code) whole code */
    if (digits.length > 1) {
      this.setCode(digits.slice(0, CODE_LENGTH.length));
      return;
    }

    const { value } = this.state;
    if (value.length >= CODE_LENGTH.length) return;
    this.setCode((value + digits).slice(0, CODE_LENGTH.length));
  };

  handlePaste = (e) => {
    const clipboard = e.clipboardData || window.clipboardData;
    const digits = ((clipboard && clipboard.getData('text')) || '').replace(/\D/g, '');
    if (!digits) return;

    e.preventDefault();
    this.setCode(digits.slice(0, CODE_LENGTH.length));
  };


  handleFocus = () => {
    this.input.current.focus();
    this.setState({ focused: true });
  };

  handleBlur = () => {
    this.setState({
      focused: false,
    });
  };

  render() {
    const {
      location: { state }, error, imarkazRefCode,
      isUserExisting,
    } = this.props;
    const {
      value, focused, timer, isSubmitted, isRequestByEmail,
    } = this.state;
    const values = value.split('');

    return (
      <div className="page-container">
        <Stepper
          isStep1Completed
          isStep2Active
          title="auth.otpVerification"
        />
        <article className="page-container__content otp page-container__content--small page-container__content--adjustMarginTop">
          <p>
            {!isRequestByEmail ? (
              <FormattedHTMLMessage
                id="otp.enterOTP"
                values={{ digit: (state && state.digit) }}
              />
            ) : <span>Enter OTP code sent to your email address</span>}
          </p>

          <div className="otp__input" onClick={this.handleFocus}>
            {CODE_LENGTH.map((v, index) => {
              const selected = values.length === index;
              const filled = values.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1;
              return (
                <div key={index} className={`otp__input__box ${((selected && focused) || filled) ? 'otp__input__box--active' : ''}`}>
                  {values[index]}
                </div>
              );
            })}
            <input
              value=""
              type="tel"
              ref={this.input}
              onBlur={this.handleBlur}
              inputMode="numeric"
              autoComplete="one-time-code"
              onChange={this.handleChange}
              onPaste={this.handlePaste}
              onKeyUp={this.handleKeyUp}
              onKeyDown={this.handleKeyDown}
            />
          </div>

          {error && isSubmitted && <small className="otp__error"><FormattedMessage id="otp.invalid" /></small>}
          {isRequestByEmail && <p style={{ textAlign: 'center', fontSize: 'small' }}>If your email address is already registered, you should receive an OTP by email.</p> }

          <div className="otp__note">
            <FormattedMessage id="otp.notReceive" />
            <p>
              {timer === 0 ? (
                <>
                  <a onClick={this.handleResendCode}><FormattedMessage id="otp.resend" /></a>
                  {' '}
                  |
                  {' '}
                  {
                    !isUserExisting
                      ? <Link to={`${PATH.LOGIN}?type=email`}><strong style={{ textDecoration: 'underline', color: '#00599b' }}>Send OTP to my email</strong></Link>
                      : <a onClick={() => this.handleRequestOtpOnEmail()} style={{ textDecoration: 'underline', fontWeight: 'bold', color: '#00599b q' }}>Send OTP to my email</a>
                  }
                </>
              ) : (<FormattedMessage id="otp.requestNewcode" values={{ timer: moment(timer).zone(-120).format('mm:ss') }} />)}
            </p>
            <FormattedMessage id="otp.or" />
            <p>
              <a href={`mailto:${process.env.REACT_APP_MARKAZ_EMAIL}?subject=Technical issue with OTP - Markaz online application ${imarkazRefCode ? `(${imarkazRefCode})` : ''}`}>
                <FormattedMessage id="otp.email" />
              </a>
            </p>
          </div>
        </article>
        {/* <div className="auth-recaptcha">
            <GoogleReCaptcha
              onVerify={this.handleVerify}
              refreshReCaptcha={this.state.refreshReCaptcha}
            />
          </div> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: selectors.getToken(state),
  isUserExisting: selectors.getAuthIsUseExisting(state),
  error: state.authReducer.error,
  imarkazRefCode: state.applicantRootReducer.applicantReducer.imarkazRefCode,
});

const mapDispatchToProps = dispatch => ({
  onVerifytOTP: (otp, history, isEmailOtp, tokenCaptcha, otpType) => dispatch(authAction.verifyOTP(otp, history, isEmailOtp, tokenCaptcha, otpType)),
  onRequestOTP: (isEmail, captchaToken) => dispatch(authAction.requestOTP(isEmail, captchaToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithNavbar(Otp));
